module.exports = __webpack_public_path__ + "static/media/save-white.993515d5.svg";